module.exports = __webpack_public_path__ + "img/intro-bg-2.6bf1fb3d.jpg";